import React from "react";
import { Link } from "react-router-dom";
import "./HotelComponent.css";

const HotelCard = ({ imageUrl, altText, destination, links, link }) => {
  return (
    <div className="ecpl_rbx">
      <div className="mgdestn">
        <Link to={link}>
          <img src={imageUrl} alt={altText} />
        </Link>
      </div>
      <div className="_pckgdscrptn">
        <h5 className="htlnking">
          <Link to={link}>{destination}</Link>
        </h5>
        <div className="htlnking">
          {links.map((l, index) => (
            <Link key={index} className="htlnking-link" to={link}>
              {l}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

const HotelsContainer = () => {
  const generateHotelUrl = (city, code) => {
    const from = code; // hotel code
    const today = new Date().toISOString().split("T")[0];
    const tomorrowDate = new Date();
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    const tomorrow = tomorrowDate.toISOString().split("T")[0];

    const rooms = encodeURIComponent(
      JSON.stringify([{ adults: 2, children: 0, childrenAges: [] }])
    );

    return `/hotelmodify?from=${from}&city=${encodeURIComponent(
      city
    )}&startDate=${today}&endDate=${tomorrow}&rooms=${rooms}`;
  };

  const hotels = [
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/hyd-sm.webp",
      altText: "Hyderabad",
      destination: "Hyderabad",
      code:145710,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/goa-sm.webp",
      altText: "Goa",
      destination: "Goa",
       code:119805,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/mumb-sm.webp",
      altText: "Mumbai",
      destination: "Mumbai",
       code:144306,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/pune-sm.webp",
      altText: "Pune",
      destination: "Pune",
       code:133133,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/del-sm.webp",
      altText: "Delhi",
      destination: "Delhi",
         code:130443,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/chennai-sm.webp",
      altText: "Chennai",
      destination: "Chennai",
       code:127343,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/jaipur-sm.webp",
      altText: "Jaipur",
      destination: "Jaipur",
       code:122175,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/shimla-sm.webp",
      altText: "Dehradun",
      destination: "Dehradun",
       code:116164,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
    {
      imageUrl: "https://www.easemytrip.com/images/hotel-img/ahmd-sm.webp",
      altText: "Ahmedabad",
      destination: "Ahmedabad",
       code:100263,
      links: [
        "Hotels,",
        "Budget Hotels,",
        "3 Star Hotels,",
        "4 Star Hotels,",
        "5 Star Hotels",
      ],
    },
  ];

  return (
    <div style={{ background: "#fff", position: "relative", zIndex: "100", padding: "5px" }}>
      <div className="innerWrap">
        <div className="slchtl_mn">
          <div className="pg_tle f28 wt600">Book Hotels at Popular Destinations</div>
          <div className="_polrdestnbx mt20">
            {hotels.map((hotel, index) => (
              <HotelCard
                key={index}
                {...hotel}
                link={generateHotelUrl(hotel.destination, hotel.code)}
              />
            ))}
          </div>
        </div>
        <div className="view_btn ctmrg">
          <Link to="/hotels">View More</Link>
        </div>
      </div>
    </div>
  );
};

export default HotelsContainer;
